import { AUTH } from "@platform/constants/routes";

export const RETURN_TO_PARAM = "returnTo";

export function getSafeReturnTo(
  value: string | null | undefined,
): string | null {
  if (!value || !value.startsWith("/") || value.startsWith("//")) return null;

  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function buildLoginPath(returnTo: string): string {
  const safeReturnTo = getSafeReturnTo(returnTo);
  if (
    !safeReturnTo ||
    safeReturnTo === AUTH.LOGIN.path ||
    safeReturnTo.startsWith(`${AUTH.LOGIN.path}?`)
  ) {
    return AUTH.LOGIN.path;
  }

  const params = new URLSearchParams();
  params.set(RETURN_TO_PARAM, safeReturnTo);
  return `${AUTH.LOGIN.path}?${params.toString()}`;
}
